import { RemoteCreateUser } from 'data/usecases';
import { makeApiUrlUsers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateUser = (): RemoteCreateUser => {
  return new RemoteCreateUser(makeApiUrlUsers(), makeAxiosHttpClient());
};
